import { Component } from '@angular/core';
import { Title } from "@angular/platform-browser";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { BreadcrumbsComponent } from '../shared/components/breadcrumbs.component';
import { TranslateService } from '@ngx-translate/core';

const titleTranslations: { [key: string]: string } = {
  'Adicionar': 'front.adicionar',
  'Adicionar Laudo CD': 'front.addLaudoCD',
  'Adicionar Laudo Técnico': 'front.addLaudoTecnico',
  'Adicionar Observação': 'front.addObservacao',
  'Adicionar Observação Fixa': 'front.addObservacaoFixa',
  'Adicionar Responsável Técnico': 'front.addResponsavelTecnico',
  'Adicionar Stakeholder': 'front.addStakeholder',
  'Adicionar Usuário': 'front.addUsuario',
  'Adicionar Viagem': 'front.addViagem',
  'Armadores': 'front.menuArmadores',
  'Arquivos': 'front.arquivos',
  'Aviso de Teste de Etilômetro': 'front.avisoTesteEtilometro',
  'Aviso de Teste do Etilômetro': 'front.avisoTesteEtilometro',
  'Bancos': 'front.menuBancos',
  'Cargo': 'front.cargo',
  'Cargos': 'front.menuUsuariosCargos',
  'Cargos de Usuários': 'front.menuUsuariosCargos',
  'Categorias': 'front.menuCategoriasMercadorias',
  'Classificação': 'front.menuClassificacaoMercadorias',
  'Clientes': 'front.menuClientes',
  'Coloracao': 'front.menuColoracaoMercadorias',
  'Coloração': 'front.menuColoracaoMercadorias',
  'Conclusão': 'front.conclusao',
  'Conclusões': 'front.menuFichasConclusoes',
  'Configurações': 'front.menuConfiguracoes',
  'Containers': 'front.menuContainers',
  'Controle Financeiro': 'front.menuControleFinanceiro',
  'Dashboard': 'front.menuDashboardFinanceiro',
  'Dashboard Financeiro': 'front.menuDashboardFinanceiro',
  'Defeitos': 'front.menuDefeitosMercadorias',
  'Dispositivo': 'front.menuDispositivos',
  'Dispositivos': 'front.menuDispositivos',
  'Editar': 'front.editar',
  'Editar Cargo': 'front.editarCargo',
  'Editar Viagem': 'front.editarViagem',
  'Embalagens': 'front.menuEmbalagensMercadorias',
  'Equipamentos': 'front.menuEquipamentos',
  'Exames': 'front.menuExames',
  'Exportadores': 'front.menuExportadores',
  'Fatura PDF': 'front.faturaPdf',
  'Faturas': 'front.menuFaturas',
  'Ficha': 'front.ficha',
  'Ficha PDF': 'front.fichaPdf',
  'Fichas': 'front.menuFichas',
  'Financeiro': 'front.menuFinanceiro',
  'Financeiro Clientes': 'front.menuClientes',
  'Follow Up': 'front.menuFollowUp',
  'Gerar PDF': 'front.gerarPDF',
  'Label Foto': 'front.labelFoto',
  'Labels Fotos': 'front.menuLabelsFotos',
  'Laudo CD': 'front.laudoCD',
  'Laudo PDF': 'front.laudoPDF',
  'Laudo Técnico': 'front.laudoTecnico',
  'Laudos CD': 'front.menuLaudosCD',
  'Laudos PDF': 'front.menuLaudosPdf',
  'Laudos Técnicos': 'front.menuLaudosTecnicos',
  'Listagem': 'front.listagem',
  'Locais': 'front.menuLocais',
  'Local': 'front.local',
  'Login': 'front.login',
  'Mercadorias': 'front.menuMercadorias',
  'Minhas Fichas': 'front.menuMinhasFichas',
  'Moeda': 'front.moeda',
  'Moedas': 'front.menuMoedas',
  'Não Autorizado': 'front.naoAutorizado',
  'Navio': 'front.navio',
  'Navios': 'front.menuNavios',
  'Observação': 'front.observacao',
  'Observação Fixa': 'front.observacaoFixa',
  'Observações': 'front.menuFichasObservacoes',
  'Observações Fixas': 'front.observacoesFixas',
  'Painel': 'front.painel',
  'Países': 'front.menuPaises',
  'Preliminares': 'front.preliminares',
  'Previstas': 'front.menuFichasPrevistas',
  'Protestos': 'front.menuFichasProtestos',
  'Relatório Completo': 'front.menuRelatorioCompleto',
  'Relatório RMCV': 'front.menuRelatorioRmcv',
  'Responsáveis Técnicos': 'front.responsaveisTecnicos',
  'Stakeholders': 'front.menuStakeholders',
  'Terminais': 'front.menuTerminais',
  'Teste de Sopro': 'front.menuTesteSopro',
  'Testes de Sopro': 'front.menuTesteSopro',
  'Teste de Álcool': 'front.menuTesteSopro',
  'Teste de Alcool': 'front.menuTesteSopro',
  'Teste de Sopro PDF': 'front.menuTesteSopro',
  'Teste de Álcool PDF': 'front.menuTesteSopro',
  'Tipo Transporte': 'front.menuTipoTransporte',
  'Tipo Unidade': 'front.menuTipoUnidade',
  'Transportadora': 'front.transportadora',
  'Transportadoras': 'front.menuTransportadoras',
  'Transporte': 'front.transporte',
  'Transportes': 'front.menuTransportes',
  'Unidades': 'front.menuUnidades',
  'Unidades de Medidas': 'front.menuUnidadesMedidas',
  'Usuários': 'front.menuUsuarios',
  'Variedades': 'front.menuVariedadesMercadorias',
  'Veículos': 'front.menuVeiculos',
  'Veículos Corrida': 'front.menuVeiculosCorridas',
  'Viagens': 'front.menuViagensTransportes',
  'Visualizar': 'front.visualizar',
  'Visualizar Laudo CD': 'front.visualizarLaudoCD',
  'Visualizar Laudo Técnico': 'front.visualizarLaudoTecnico',
  'Visualizar Observação': 'front.visualizarObservacao',
  'Visualizar Observação Fixa': 'front.visualizarObservacaoFixa',
  'Visualizar PDF': 'front.visualizarPDF',
  'Visualizar Responsável Técnico': 'front.visualizarResponsavelTecnico',
  'Visualizar Stakeholder': 'front.visualizarStakeholder',
  'Visualizar Usuário': 'front.visualizarUsuario'
};

@Component({
  selector: 'page-header',
  templateUrl: 'page-header.component.html'
})
export class PageHeaderComponent {
  titulo: string;
  icone: string;
  rawTitles: string[] = [];

  constructor(titleService: Title, router: Router, activatedRoute: ActivatedRoute, private translate: TranslateService) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.rawTitles = this.getTitle(router.routerState, router.routerState.root);
        this.atualizaTitulo();
      }
    });

    this.translate.onLangChange.subscribe(() => {
      this.atualizaTitulo();
    });
  }

  atualizaTitulo() {
    var translatedTitles = this.rawTitles.map(t => {
      const key = titleTranslations[t];
      return key ? this.translate.instant(key) : t;
    });
    this.titulo = translatedTitles.join(' - ');
  }

  // collect that title data properties from all child routes
  // there might be a better way but this worked for me
  getTitle(state, parent) {
    var data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push(... this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }
}



// WEBPACK FOOTER //
// ./src/app/painel/page-header.component.ts